export const isStatelessComponent = (Component: any) =>
  !(Component.prototype && Component.prototype.render);
